import React, { useContext, useState } from 'react';
import { Alert, Button, Modal } from 'antd';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { TicketAISummaryResult } from '@totem/components/ticketing/ticketing';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';

const styles = {
  button: {
    fontSize: '36px',
    marginLeft: '0.5em',
  },
};

const RequestSummaryButton = () => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const { ticket } = useContext(TicketContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [summary, setSummary] = useState<TicketAISummaryResult | null>(null);

  if (!permissions.internal.hasPermissions(userProfile)) {
    return null;
  }

  const handleRequestSummary = () => {
    setLoading(true);

    fetch(`${TICKET_ENDPOINT}/${ticket.ticket.id}/aiSummary`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => (CheckResponseShowError(res) ? res.json() : null))
      .then((result: TicketAISummaryResult | null) => {
        if (result) {
          setSummary(result);
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div style={styles.button}>
        <Button
          title={'Request Summary'}
          size={'small'}
          loading={loading}
          onClick={handleRequestSummary}
        >
          Summary
        </Button>
      </div>
      <Modal
        title={'AI-Generated Ticket Summary'}
        open={summary !== null}
        onCancel={() => setSummary(null)}
        onOk={() => setSummary(null)}
        cancelButtonProps={{ style: { display: 'none' } }}
        okText={'Close'}
      >
        <Alert
          type={'warning'}
          showIcon
          message={
            'AI generated — may be inaccurate. Verify before relying on it.'
          }
          style={{ marginBottom: 16 }}
        />
        {summary && (
          <>
            <p>{summary.summary}</p>
            <p>
              <b>Current Status:</b> {summary.currentStatus}
            </p>
            {summary.keyPoints?.length > 0 && (
              <>
                <b>Key Points</b>
                <ul>
                  {summary.keyPoints.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </>
            )}
            {summary.nextSteps?.length > 0 && (
              <>
                <b>Next Steps</b>
                <ul>
                  {summary.nextSteps.map((step) => (
                    <li key={step}>{step}</li>
                  ))}
                </ul>
              </>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default RequestSummaryButton;
